import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, ViewChild } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ComplainRegister, ComplainSearch } from '../../Models/RequestModels';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStatuses, EntityCodes, ComplainSearch_GroupBy } from '../../Models/EnumModels';
import { PMSService } from '../../Services/PMSService';
import * as _ from 'lodash';
import { ComplainService } from '../../Services/ComplainService';
import { JobSearchResult } from '../JobSearchResult/JobSearchResult';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { untilDestroyed } from 'ngx-take-until-destroy'; 

@Component({
    selector: 'JobSearchGroup',
    templateUrl: './JobSearchGroup.html'
})

export class JobSearchGroup extends BaseComponent implements OnInit, OnDestroy {
    @ViewChild('jobSearchResult') jobSearchResult: JobSearchResult;
    _Model: any;
    _RequestModel: ComplainSearch;
    DateFormat: string;
    Selected: any;
    ShowGroup: boolean = false;
    ChildInit: boolean = false;

    Rows_Add: number = 0;
    Rows_Update: number = 0;
    Rows_LastHandled: Array<number> = [];

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, protected pmsService: PMSService, public complainService: ComplainService) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnDestroy(): void {

    }

    ngOnInit(): void {
        this.DateFormat = this.masterService.GetPropertyDateFormat(null);

        this.complainService.ComplainRowChanged.pipe(untilDestroyed(this)).subscribe((data) => {
            this.onComplainRowChanged(data);
        });

        this.complainService.ComplainRowAdded.pipe(untilDestroyed(this)).subscribe((data) => {
            this.onComplainRowAdded(data);
        });
    }

    @Input("Model") set Model(Model: any) {
        this._Model = Model;
        this.SetRequestModel();
    }

    get Model() :any {
        return this._Model;
    }

    @Input("RequestModel") set RequestModel(value: ComplainSearch) {
        this._RequestModel = _.cloneDeep(value);
        this.SetRequestModel();
    }

    get RequestModel(): ComplainSearch {
        return this._RequestModel;
    }

    SetRequestModel(): void {
        if (this._Model == null || this.RequestModel == null) {
            return;
        }

        let req:any = this._RequestModel;

        if (req.GroupBy == ComplainSearch_GroupBy.None)
            return;

        switch (req.GroupBy) {
            case ComplainSearch_GroupBy.AssignedTo:
                req.AssignedTo = [this._Model.Id];
                break;
            case ComplainSearch_GroupBy.CallCategories:
                req.CallCategories = [this._Model.Id];
                break;
            case ComplainSearch_GroupBy.CallDescriptions:
                req.CallDescriptions = [this._Model.Id];
                break;
            case ComplainSearch_GroupBy.Dept:
                req.Departments = [this._Model.Id];
                break;
            case ComplainSearch_GroupBy.Location:
                req.Locations = [this._Model.Id];
                break;
            case ComplainSearch_GroupBy.Sections:
                req.Sections = [this._Model.Id];
                break;
            case ComplainSearch_GroupBy.Property:
                req.Properties = [this._Model.Id];
                break;
            case ComplainSearch_GroupBy.Priority:
                req.Priority = this._Model.Id;
                break;
        }

        req.GroupBy = ComplainSearch_GroupBy.None;
        req.PageNumber = 1;
        req.PageSize = 10;
        if (this._Model && this._Model.GroupName && this._Model.GroupName.toLowerCase() == 'crisis') {
            req['excludeCrisisJobFilter'] = true;
        } else {
            req['excludeCrisisJobFilter'] = false;
        }

        // console.info(this._RequestModel);
    }

    onToggle(): void {
        this.ShowGroup = !this.ShowGroup;
        if (this.ChildInit)
            return;

        this.jobSearchResult.Show();
        this.ChildInit = true;
    }

    isFilterMatch(data: any): boolean {
        let m = true;

        if (this.RequestModel.AssignedTo != null && this.RequestModel.AssignedTo.length > 0) {
            if (this.RequestModel.AssignedTo.findIndex(a => a == data.AssignedTo) < 0)
                return false;
        }

        if (this.RequestModel.CallCategories != null && this.RequestModel.CallCategories.length > 0) {
            if (this.RequestModel.CallCategories.findIndex(a => a == data.CategoryId) < 0)
                return false;
        }

        if (this.RequestModel.CallDescriptions != null && this.RequestModel.CallDescriptions.length > 0) {
            if (this.RequestModel.CallDescriptions.findIndex(a => a == data.CallDescriptionsId) < 0)
                return false;
        }

        if (this.RequestModel.Departments != null && this.RequestModel.Departments.length > 0) {
            if (this.RequestModel.Departments.findIndex(a => a == data.DeptId) < 0)
                return false;
        }

        if (this.RequestModel.Locations != null && this.RequestModel.Locations.length > 0) {
            if (this.RequestModel.Locations.findIndex(a => a == data.LocationId) < 0)
                return false;
        }

        if (this.RequestModel.LoggedBy != null && this.RequestModel.LoggedBy.length > 0) {
            if (this.RequestModel.LoggedBy.findIndex(a => a == data.LoggedBy) < 0)
                return false;
        }

        if (this.RequestModel.Properties != null && this.RequestModel.Properties.length > 0) {
            if (this.RequestModel.Properties.findIndex(a => a == data.PropertyId) < 0)
                return false;
        }

        if (this.RequestModel.RequestedBy != null && this.RequestModel.RequestedBy.length > 0) {
            if (this.RequestModel.RequestedBy.findIndex(a => a == data.RequestedByStaffId) < 0)
                return false;
        }

        if (this.RequestModel.Sections != null && this.RequestModel.Sections.length > 0) {
            if (this.RequestModel.Sections.findIndex(a => a == data.SectionId) < 0)
                return false;
        }

        if (this.RequestModel.VIPCodes != null && this.RequestModel.VIPCodes.length > 0) {
            if (this.RequestModel.Sections.findIndex(a => a == data.Vip) < 0)
                return false;
        }

        if (this.RequestModel.Priorities != null && this.RequestModel.Priorities.length > 0) {
            if (this.RequestModel.Priorities.findIndex(a => a == data.Priority) < 0)
                return false;
        }

        return m;
    }

    onComplainRowAdded(data: any): void {
        //console.info(data);

        if (this.isFilterMatch(data) == false) {
            return;
        }

        if (this.Rows_LastHandled.findIndex(a => a == data.ComplainId) < 0) {
            this.Rows_Add = this.Rows_Add + 1;
            this.Rows_LastHandled.push(data.ComplainId);
        }
    }

    onComplainRowChanged(data: any): void {
        if (this.isFilterMatch(data) == false) {
            return;
        }

        if (this.Rows_LastHandled.findIndex(a => a == data.ComplainId) < 0) {
            this.Rows_Update = this.Rows_Update + 1;
            this.Rows_LastHandled.push(data.ComplainId);
        }
    }

    onResultRefresh(): void {
        this.Rows_Add = 0;
        this.Rows_Update = 0;
    }
}
